import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react';
import { deleteRole } from '../api/auth';
import { getApiErrorMessage } from '../utils/apiError';

const DeleteGroupModal = ({ isOpen, onClose, groupName, refetch }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const toast = useToast();

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteRole(groupName);
      toast({
        title: 'Group Deleted',
        description: 'Group has been successfully deleted.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      refetch();
      onClose();
    } catch (error) {
      console.error('Error deleting group:', error);
      toast({
        title: 'Error',
        description: getApiErrorMessage(
          error,
          error.response?.status === 403
            ? 'This group cannot be deleted.'
            : 'Failed to delete group.'
        ),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Group</ModalHeader>
        <ModalBody>
          <Text>
            Are you sure you want to delete the group{' '}
            <Text as="strong">{groupName}</Text>? Every user currently in this
            group will be logged out.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="red"
            mr={3}
            onClick={handleDelete}
            isLoading={isDeleting}
          >
            Delete
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteGroupModal;
